import { Button, Container, Heading, Notice, Separator } from 'telia-front-react';
import { observer } from 'mobx-react';
import * as React from 'react';
import WebApi from '../components/WebApi';
import { API } from '../util/ApiUtil';
import ErrorUtil from '../util/ErrorUtil';
import useStores from '../stores/UseStores';

const DealerSessionExpirationNotice = observer((): React.JSX.Element => {
  const {
    translateStore: { translate },
  } = useStores();
  const [sessionExpirationTimeString, setSessionExpirationTimeString] = React.useState<string>('');
  const [sessionExtended, setSessionExtended] = React.useState<boolean>(false);

  React.useEffect(() => {
    API.get('/admin/session-expiration-time')
      .then((res) => {
        const date = new Date(res.data);
        const hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
        const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
        setSessionExpirationTimeString(`${hours}:${minutes}`);
      })
      .catch((err) => ErrorUtil.pushErrorToTeliaRumAndLog(err));
  }, []);

  const handleOnClick = async () => {
    try {
      await API.post('/admin/extend-session');
      setSessionExtended(true);
    } catch (e: Error | string | any) {
      ErrorUtil.pushErrorToTeliaRumAndLog(e);
    }
  };

  if (sessionExtended) {
    return <WebApi />;
  }

  return (
    <Container>
      <Notice>
        <Heading element="h1" className="h4 text-bold">
          {translate('dealer.session_expiration_notice.heading', { time: sessionExpirationTimeString })}
        </Heading>
        <Separator spacing="xxsmall" color="invisible" />
        <p className="h4">{translate('dealer.session_expiration_notice.content')}</p>
        <Separator spacing="xxsmall" color="invisible" />
        <Button text={translate('dealer.session_expiration_notice.button_label')} onClick={handleOnClick} iconRight="#arrow-right" />
      </Notice>
    </Container>
  );
});

export default DealerSessionExpirationNotice;
